import { HeaderTwoColumnLayoutSkeleton } from 'layouts';
import { Skeleton } from 'ui';

type P = {
  view: 'detail' | 'list';
};

const GroupLayoutSkeleton = ({ view }: P) => {
  if (view === 'list') {
    return (
      <>
        <Skeleton active paragraph={{ rows: 1 }} title={false} />
        <Skeleton active paragraph={{ rows: 14 }} title={false} />
      </>
    );
  }

  return (
    <HeaderTwoColumnLayoutSkeleton
      header={{ paragraph: { rows: 10 } }}
      left={[
        { paragraph: { rows: 4 } },
        { paragraph: { rows: 8 } },
        { paragraph: { rows: 8 } },
        { paragraph: { rows: 8 } },
        { paragraph: { rows: 8 } },
      ]}
      right={[{ paragraph: { rows: 6 } }]}
    />
  );
};

export default GroupLayoutSkeleton;
